// extracted by mini-css-extract-plugin
export default {"page":"cY-z","cartModal":"dY-z","checkout":"eY-z","placeholder":"fY-z","account":"gY-z"};